export enum AccountState {
  PENDING_EMAIL_VERIFICATION = "PENDING_EMAIL_VERIFICATION",
  PENDING_PHONE_VERIFICATION = "PENDING_PHONE_VERIFICATION",
  ACTIVE = "ACTIVE",
}

export enum Severity {
  INFO = "info",
  WARN = "warn",
  SUCCESS = "success",
  DANGER = "danger",
}

export enum WeeklyOrders {
  ONE_TO_TEN = "1-10",
  ELEVEN_TO_TWENTYFIVE = "11-25",
  TWENTY_SIX_TO_FIFTY = "26-50",
  FIFTY_ONE_TO_ONEHUNDRED = "51-100",
  ONEHUNDRED_ONE_TO_FIVEHUNDRED = "101-500",
  OVER_FIVE_HUNDRED = "500+",
  UNKNOWN = "UNKNOWN",
}

export enum ApplicantRole {
  OWNER = "OWNER",
  OPERATIONS_MANAGER = "OPERATIONS_MANAGER",
  RESTAURANT_MANAGER = "RESTAURANT_MANAGER",
  ASSISTANT_MANAGER = "ASSISTANT_MANAGER",
  CHEF = "CHEF",
}

export enum TransportType {
  CAR = "car",
  SCOOTER = "scooter",
  BIKE = "bike",
}

export enum VerificationTokenType {
  RESET_PASSWORD = "reset_password",
  VERIFY_EMAIL = "verify_email",
  VERIFY_PHONE = "verify_phone",
}

export enum OrderStatus {
  WAITING_FOR_PAYMENT = "waiting_for_payment",
  PROCESSING = "processing",
  COOKING = "cooking",

  WAITING_FOR_RIDER = "waiting_for_rider",
  WAITING_FOR_PICKUP = "waiting_for_pickup",

  DRIVER_ASSIGNED = "driver_assigned",
  COLLECTED = "collected",

  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export enum FeeType {
  DELIVERY = "delivery",
  SMALL_ORDER = "small_order",
  SERVICE = "service",
}
